import React, { useEffect, useRef } from 'react';
import moment from 'moment-timezone';
import { Box, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { msec } from 'src/utils/tools';

const LiveClock = () => {
  const tz = localStorage.getItem('timezone') || moment.tz.guess();
  const dateRef = useRef(null);
  const clockRef = useRef(null);

  useEffect(() => {
    const updateClock = () => {
      const now = moment.tz(msec(Date.now()), tz);
      if (dateRef.current) dateRef.current.textContent = now.format('YYYY-MM-DD');
      if (clockRef.current) clockRef.current.textContent = now.format('HH:mm:ss');
    };

    updateClock();

    const now = Date.now();
    const delay = 1000 - (now % 1000);

    const timeout = setTimeout(() => {
      updateClock();
      const interval = setInterval(updateClock, 1000);
      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timeout);
  }, [tz]);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        padding: '8px 12px',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        zIndex: 999999,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        fontFamily: 'inherit',
      }}
    >
      <Icon icon="mdi:clock-outline" width="20" height="20" />
      <Typography ref={dateRef} sx={{ fontFeatureSettings: '"tnum"' }} />
      <Typography ref={clockRef} sx={{ fontFeatureSettings: '"tnum"', fontWeight: 550 }} />
    </Box>
  );
};

export default React.memo(LiveClock);
